import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <span className="ms-1">&copy; 2024 freshymeat.com</span>
      </div>
      {/* <div className="ms-auto">
        <a href="https://freshymeat.com" target="_blank" rel="noopener noreferrer">
          <span className="ms-1">&copy; 2024 freshymeat.com</span>
        </a>
      </div> */}
    </CFooter>
  )
}

export default React.memo(AppFooter)
